<app-loading [type]="'spinner'" [showLoading]="showLoading"></app-loading>
<mat-accordion>
  <mat-expansion-panel class="width-expansion-panel">
    <mat-expansion-panel-header class="bg-color-gray"  (click)="loadComments()">
      <mat-panel-title>
        <!-- {{ 'SEE_COMMENTS' | translate }} -->
          <span>Ver comentários  ({{ handleCountComments() }})</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-container *ngFor="let comment of comments;">
      <div class="comment-container" [ngClass]="comment.readUserName ? 'comment-readed' : 'comment-unreaded'">
        <section class="container column-reverse no-border">
          <div class="item grow0">
            <p class="comment-author">{{ comment.userName }} <app-occurrence-comment-read-by [comment]="comment"></app-occurrence-comment-read-by></p>
            <p class="comment-creation">{{ comment.creationDateTime | replace:'-':'/' | date:'dd/MM/yyyy' }}</p>
          </div>
        </section>
        <section class="container column-reverse no-border">
          <div class="item grow0">
            <span class="wrap-comment" #commentDesc [ngClass]="!comment.showCompletComment ? 'hidden-see' : ''" ><span [outerHTML]="comment.description | replaceLineBreak"></span></span>
            <div *ngIf="comment.storedDocument" class="iterable-atach-comments">
              <div *ngFor="let document of comment.storedDocument; let indexDoc = index"  class="file-data" (click)="downloadDocumentOfCommentById(document.id)">
                <p [matTooltip]="document.documentName">{{document.simplifiedName ? document.simplifiedName : document.documentName}}</p>
                <p class="size-atach">{{document.textSize}}</p>
              </div>
            </div>
            <div>
                <app-occurrence-read-manager [comment]="comment"></app-occurrence-read-manager>
                <div class="item grow1">
                    <span class="btn-read-more" *ngIf="comment.showCompletComment && comment.simplifiedComment || (!comment.showViewMore && comment.showCompletComment)"  (click)="comment.showCompletComment = !comment.showCompletComment; comment.showViewMore = !comment.showViewMore">{{'SEE_LESS'  | translate}}</span>
                    <span class="btn-read-more" *ngIf="!comment.showCompletComment && comment.simplifiedComment || (comment.showViewMore && !comment.showCompletComment)"  (click)="comment.showCompletComment = !comment.showCompletComment;  comment.showViewMore = !comment.showViewMore">{{ 'SEE_MORE' | translate}}</span>
                </div>
            </div>
          </div>

        </section>
      </div>
    </ng-container>
  </mat-expansion-panel>
</mat-accordion>
